import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportLocationsResponse } from "./type";

export async function exportLocations(): Promise<ExportLocationsResponse> {
  const url = apiPaths.locations.export;

  const response = await apiClient.get<ExportLocationsResponse>(url);

  return response.data;
}
